import { ForgotPasswordForm } from "@/routes/auth/_auth-layout/-components/auth/forgot-password.form";
import { FORGOT_PASSWORD_ERROR_RAW } from "@/lib/utils";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";
import { zodValidator } from "@tanstack/zod-adapter";

const searchParamsSchema = z.object({
  error: FORGOT_PASSWORD_ERROR_RAW.optional(),
});

export const Route = createFileRoute("/auth/_auth-layout/forgot-password")({
  validateSearch: zodValidator(searchParamsSchema),
  component: () => <ForgotPassword />,
});

function ForgotPassword() {
  const search = Route.useSearch();
  return (
    <div className="flex w-full flex-col  items-center rounded-3xl bg-white text-left">
      <img
        src="/volume-logo.svg"
        className="self-center"
        width={200}
        height={200}
        alt="Volume logo"
      />
      {search.error === "EXPIRED" ? (
        <>
          <h1 className="mt-8 px-8 text-center text-3xl font-extrabold">
            Password Reset Link Expired
          </h1>
          <p className="mt-4 text-center text-sm text-gray-500">
            Please request a new password reset email.
          </p>
        </>
      ) : (
        <>
          <h1 className="mt-8 px-8 text-center text-3xl font-extrabold">
            Forgot Your Password?
          </h1>
          <p className="mt-8 text-center text-sm text-gray-500">
            Enter your email address to receive a password reset link.
            <br />
            <br />
            If you do not receive an email, please check your spam folder.
          </p>
        </>
      )}
      <ForgotPasswordForm />
    </div>
  );
}
